<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { useVModel } from "@vueuse/core";
import { cn } from "@/lib/utils";

const props = defineProps<{
    defaultValue?: string | number;
    modelValue?: string | number;
    class?: HTMLAttributes["class"];
}>();

const emits = defineEmits<{
    (e: "update:modelValue", payload: string | number): void;
}>();

const modelValue = useVModel(props, "modelValue", emits, {
    passive: true,
    defaultValue: props.defaultValue,
});
</script>

<template>
    <input
        v-model="modelValue"
        :class="
            cn(
                'dark:bg-iron-950 dark:ring-offset-iron-950 h-10 rounded-lg border-iron-300 bg-white px-3 py-2 text-sm shadow-xs ring-offset-white file:text-sm file:font-medium placeholder:text-iron-500 focus-visible:border-z-primary-300 focus-visible:ring-z-primary-100 dark:border-iron-800 dark:placeholder:text-iron-400 dark:focus-visible:ring-iron-300 flex w-full border file:border-0 file:bg-transparent focus-visible:ring-2 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50',
                props.class ?? '',
            )
        "
    />
</template>
